<div class="registration-section-container">
  <div class="registration-left">
    <div class="registration-left-content">
      <div class="registration-left-icon">
        <app-icon [icon]="Icons.logo"/>
      </div>
      <div class="registration-left-content-text">
        <div>Gold Star Sports Management</div>
        <div>2350 Green Road. Suite 100B</div>
        <div>Ann Arbor, Michigan 48105</div>
<!--        <a [href]="file" download>Скачать презентацию о компании</a>-->
      </div>
    </div>
  </div>
  <div class="registration-right">
    <div class="registration-right-title">
      РЕГИСТРАЦИЯ
    </div>
    <div class="registration-right-subtitle">
      <a [href]="file" download>
        Скачать памятку документов для участия в сборе
      </a>
    </div>
    <div class="registration-right-content">
      <div class="registration-right-content-double" style="margin-top: 24px">
        <input [(ngModel)]="applicantName" placeholder="ФИО заявителя">
        <input [(ngModel)]="juniorName" placeholder="ФИО игрока">
      </div>
      <div class="registration-right-content-double">
        <input [(ngModel)]="jersey" placeholder="Размер джерси">
        <input [(ngModel)]="form" placeholder="Размер формы для ОФП">
      </div>
      <div class="registration-right-content-solo">
        <input [(ngModel)]="juniorBirthDate" placeholder="Год рождения игрока">
      </div>
       <div class="registration-right-content-double">
         <input [(ngModel)]="applicantPhone" placeholder="Номер телефона заявителя">
         <input [(ngModel)]="applicantMail" placeholder="Почта заявителя">
      </div>
      <div class="registration-right-content-solo">
        <input [(ngModel)]="juniorTeam" placeholder="Команда">
      </div>
      <div class="registration-right-content-solo">
        <textarea #messageTextarea [(ngModel)]="additionalInfo" placeholder="Информация, о которой желаете сообщить дополнительно" (input)="onInput(messageTextarea)"></textarea>
      </div>
      <div class="registration-right-content-solo">
        <div
          class="registration-right-content-solo-checkbox"
          [class]="checkbox ? 'registration-right-content-solo-checkbox-active' : 'registration-right-content-solo-checkbox-inactive'"
          (click)="checkbox = !checkbox"
        >
          <app-icon *ngIf="checkbox" [icon]="Icons.check"/>
        </div>
        <p>Нажимая кнопку отправить Вы соглашаетесь с обработкой  <a download [href]="file">персональных данных</a></p>

      </div>
    </div>
    <div class="registration-right-button-container">
      <div class="registration-right-button" (click)="onSubmit()" *ngIf="!submit">
        Отправить
      </div>
      <div class="registration-right-button registration-right-button-active" *ngIf="submit">
        Отправлено
      </div>
      <p *ngIf="alert">Необходимо принять условия</p>
    </div>
  </div>
</div>
